"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createYearsArray = void 0;
var createYearsArray = function (start, end) {
    return Array.from({ length: end - start + 1 })
        .fill(start)
        .map(function (year, index) { return year + index; });
};
exports.createYearsArray = createYearsArray;
